export { default } from './ContentPhotos'
